import React from "react"
import PropTypes from "prop-types"
import { Box, Paper } from "@mui/material"
import { getMemoriaCalculoModalConfig } from "./../memoria-calculo-sections/configs/memoria-calculo-modal-config"
import {
    MemoriaCalculoFieldsSection,
    MemoriaCalculoTableSection,
    memoriaCalculoPaperSx,
} from "./../memoria-calculo-sections/memoria-calculo-sections"

export const MemoriaCalculoPanel = ({ data, hasResultado, puparData, puMtmData }) => {
    const config = getMemoriaCalculoModalConfig({ data, hasResultado, puparData, puMtmData })

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Paper elevation={0} sx={{ ...memoriaCalculoPaperSx, p: 3 }}>
                <MemoriaCalculoFieldsSection
                    title={config.parametros.title}
                    sections={config.parametros.sections}
                />
            </Paper>

            <Paper elevation={0} sx={{ ...memoriaCalculoPaperSx, p: 3 }}>
                <MemoriaCalculoTableSection
                    title={config.resultado.title}
                    columns={config.resultado.sections[0].columns}
                    rows={config.resultado.sections[0].rows}
                />
            </Paper>

            <Paper elevation={0} sx={{ ...memoriaCalculoPaperSx, p: 3 }}>
                <MemoriaCalculoTableSection
                    title={config.pupar.title}
                    columns={config.pupar.sections[0].columns}
                    rows={config.pupar.sections[0].rows}
                />
            </Paper>

            <Paper elevation={0} sx={{ ...memoriaCalculoPaperSx, p: 3 }}>
                <MemoriaCalculoTableSection
                    title={config.pu_mtm.title}
                    columns={config.pu_mtm.sections[0].columns}
                    rows={config.pu_mtm.sections[0].rows}
                />
            </Paper>
        </Box>
    )
}

MemoriaCalculoPanel.propTypes = {
    data: PropTypes.object,
    hasResultado: PropTypes.bool,
    puparData: PropTypes.array,
    puMtmData: PropTypes.array,
}

MemoriaCalculoPanel.defaultProps = {
    hasResultado: false,
    puparData: [],
    puMtmData: [],
}